<template>
  <PvCard>
    <template #title>
      <h2 class="fs-2">ORGANIZATION MANAGEMENT</h2>
    </template>
    <template #content>
      <dl class="p-3 d-flex flex wrap gap-3 align-items-center text-center justify-content-center">
        <MnRow :colSpan="{ sm: 12 }" class="row-equal-height">
          <MnColumn cols="4" class="d-flex">
            <StatisticItem class="flex-fill" label="Organizations Pending Approval" :value="dashboardStore?.organizationCounts?.pendingOrganizationCount" >
              <template #default>
                <PvButton label="Review Approvals"
                          arial-label="Review Organizations Pending Approval"
                          @click="handleReviewOrganizations"
                          rounded />
              </template>
            </StatisticItem>
          </MnColumn>
          <MnColumn cols="4" class="d-flex">
            <StatisticItem class="flex-fill" label="Pending Exceptions" :value="dashboardStore?.organizationCounts?.pendingExceptionCount" >
              <template #default>
                <PvButton label="Review Exceptions"
                          arial-label="Review Reporting Exceptions"
                          @click="handleReviewExceptions"
                          rounded />
              </template>
            </StatisticItem>
          </MnColumn>
          <MnColumn cols="4" class="d-flex">
            <StatisticItem class="flex-fill" label="Open Conversations" :value="dashboardStore?.organizationCounts?.openConversationCount" >
              <template #default>
                <PvButton label="View Conversations"
                          arial-label="View Conversations"
                          @click="handleViewConversations"        
                          rounded />
              </template>
            </StatisticItem>
          </MnColumn>
        </MnRow>
      </dl>
    </template>
  </PvCard>
</template>

<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core

// Components
import StatisticItem from '@/components/dashboard/StatisticItem.vue';
import MnColumn from '@/components/common/MnColumn.vue';
import MnRow from '@/components/common/MnRow.vue';

// Composables
import { usePageHelper } from '@/composables/pageHelper';

// Stores
import { useProgramDashboardStore } from '../stores/ProgramDashboardStore';

// Constants and Utils


// ===============================
// PROPS & EMITS
// ===============================


// ===============================
// COMPOSABLES & STORES
// ===============================
const dashboardStore = useProgramDashboardStore();
const { navigateToRouteName } = usePageHelper();
// ===============================
// REACTIVE STATE
// ===============================


// ===============================
// CONSTANTS
// ===============================


// ===============================
// COMPUTED PROPERTIES
// ===============================


// ===============================
// METHODS
// ===============================
const handleReviewOrganizations = () => {
  navigateToRouteName('registrationapprovals');
};

const handleReviewExceptions = () => {
  navigateToRouteName('reportingexceptions');
};

const handleViewConversations = () => {
  navigateToRouteName('conversations');
};

// ===============================
// WATCHERS
// ===============================


// ===============================
// LIFECYCLE HOOKS
// ===============================


// ===============================
// EXPOSE
// ===============================


</script>

<style scoped>
.row-equal-height {
  display: flex;
  flex-wrap: wrap;
}

.flex-fill {
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>